<template>
  <div class="BgManualMarkers">
    <div
      v-for="point in points"
      :key="point.id"
      :class="`BgManualMarkers__marker ${
        point.id === selectedId ? 'BgManualMarkers__marker--active' : ''
      }`"
      :style="{ left: getLeft(point.timestamp_top) }"
      title="Manual feedback"
      @click.stop="$emit('select', point.id)"
    ></div>
  </div>
</template>

<style scoped lang="scss">
@import "./styles.scss";
</style>

<script>
export default {
  name: "bg-manual-markers",
  props: {
    points: {
      type: Array,
      default: () => [],
    },
    startedAt: Number,
    duration: Number,
    selectedId: Number,
  },
  methods: {
    getLeft(timestamp) {
      const diff = timestamp - this.startedAt;
      return (diff / (this.duration * 1000)) * 100 + "%";
    },
  },
};
</script>
